import { Card, CardContent, Typography, Grid } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from "react-redux";
import { formatDinero } from "./../../../../utils/formatDinero"
import { GraficaPerdidas } from "./GrficaPerdidas";
import { GraficaBarras } from "./GraficaBarras";
const useStyles = makeStyles({
    main: {
        padding: "2%"
    },
    container: {
        display: "flex",
        flexFlow: "column",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "0.1rem",
    },
    root: {
        width: '100%',
        minWidth: 180,
        marginTop: "1rem"
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 10,
        marginTop: 10,
        padding: 2
    },
});

const calcularProcentaje = ({ monto, total }) => {
    let resultado = monto * 100
    resultado = resultado / total
    return Math.trunc((resultado < 0) ? resultado * -1 : resultado)
}
const calTipoCambio = ({ monto, tipoCambio }) => {
    return monto / tipoCambio
}
const calUtilidad = ({ utilidadPaquete, utlidadCorte, utlidadSobrante }) => {
    return utilidadPaquete + utlidadCorte + utlidadSobrante
}
const Cabecera = () => {
    const classes = useStyles()
    const { comprasDetalle } = useSelector(store => store.cliente)
    let totalUtilidad = calUtilidad({
        utilidadPaquete: comprasDetalle.utilidadPaquete,
        utlidadCorte: comprasDetalle.utilidadCorteCaja,
        utlidadSobrante: comprasDetalle.utilidadSobranteCompras
    })
    let totalPaqueteDolares = comprasDetalle.paquete?.Monto_Paquete
    if (comprasDetalle?.paquete?.Cotizacion?.Moneda?.id_moneda !== comprasDetalle?.paquete?.MonedaProveedor?.id_moneda)
        totalPaqueteDolares = calTipoCambio({ monto: comprasDetalle.paquete?.Monto_Paquete, tipoCambio: comprasDetalle.paquete?.TipoCambioPrevisto })

    const porcentajePerdida = calcularProcentaje({ monto: comprasDetalle.sobranteComprasLiquidar, total: totalUtilidad })
    const porcentajeUtlidadPaquete = calcularProcentaje({ monto: comprasDetalle.utilidadPaquete, total: totalUtilidad })
    const porcentajeUtidadCorteCaja = calcularProcentaje({ monto: comprasDetalle.utilidadCorteCaja, total: totalUtilidad })
    const porcentajeSobranteCompras = calcularProcentaje({ monto: comprasDetalle.utilidadSobranteCompras, total: totalUtilidad })
    const porcentajeUtlidadTotalReal = calcularProcentaje({ monto: comprasDetalle.utilidadTotal, total: totalPaqueteDolares })
    const porcentajeTotalPagadoProveedor = calcularProcentaje({ monto: comprasDetalle.totalPagado, total: totalPaqueteDolares })
    return (
        <div className={classes.main}>
            <div className={classes.container}>
                <Card className={classes.root}>
                    <CardContent>
                        <Grid container>
                            <Grid item xs={12}>
                                <div style={{ marginBottom: "1rem" }}>
                                    <Typography color="textSecondary" variant="h6" >
                                        Datos generales
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item xs={12} >
                                <div style={{ marginBottom: "1rem" }}>
                                    <Grid container>

                                        <Grid item xs={4}>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Precio paquete:
                                                </Typography>
                                                <Typography color="textPrimary" >
                                                    {`${formatDinero(comprasDetalle.paquete?.Monto_Paquete)}  ${comprasDetalle?.paquete?.Cotizacion?.Moneda?.Clave}`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos}>
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Monto ahorrado cliente:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(comprasDetalle.montoAhorrado)} ${comprasDetalle?.paquete?.Cotizacion?.Moneda?.Clave}`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos}>
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Saldo a favor cliente:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(comprasDetalle.saldoDisponible)} ${comprasDetalle?.paquete?.Cotizacion?.Moneda?.Clave}`}
                                                </Typography>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>

                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Precio neto paquete:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(comprasDetalle.precioNetoTotalCliente)} ${comprasDetalle?.paquete?.Cotizacion?.Moneda?.Clave}`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Precio neto suplmentos:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(comprasDetalle.precioNetoTotalSupCliente)} ${comprasDetalle?.paquete?.Cotizacion?.Moneda?.Clave}`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Precio neto total:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(comprasDetalle.precioNetoTotalCliente + comprasDetalle.precioNetoTotalSupCliente)} ${comprasDetalle?.paquete?.Cotizacion?.Moneda?.Clave}`}
                                                </Typography>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <div className={classes.pos}>
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Tipo cambio prevista:
                                                </Typography>
                                                <Typography color="textPrimary" >
                                                    {`${formatDinero(comprasDetalle.paquete?.TipoCambioPrevisto)}`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos}>
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Moneda proveedor:
                                                </Typography>
                                                <Typography color="textPrimary" >
                                                    {`${comprasDetalle?.paquete?.MonedaProveedor?.Clave}`}
                                                </Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Card className={classes.root}>
                    <CardContent>
                        <Grid container>
                            <Grid item xs={12}>
                                <div style={{ marginBottom: "1rem" }}>
                                    <Typography color="textSecondary" variant="h6" >
                                        Montos
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item xs={12} >
                                <div style={{ marginBottom: "1rem" }}>
                                    <Grid container>
                                        <Grid item xs={4}>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Pago proveedor previsto:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(comprasDetalle.totalPagadoPrevisto)} ${comprasDetalle?.paquete?.MonedaProveedor?.Clave}`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos} >
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Monto corte caja total prevista:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(comprasDetalle.montoCorteCajaTotalPrevisto)} ${comprasDetalle?.paquete?.MonedaProveedor?.Clave}`}
                                                </Typography>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <div className={classes.pos}>
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Pago proveedor real:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(comprasDetalle.totalPagado)} ${comprasDetalle?.paquete?.MonedaProveedor?.Clave}`}
                                                </Typography>
                                            </div>
                                            <div className={classes.pos}>
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Monto corte caja total real:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero(comprasDetalle.montoCorteCajaTotal)} ${comprasDetalle?.paquete?.MonedaProveedor?.Clave}`}
                                                </Typography>
                                            </div>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <div className={classes.pos}>
                                                <Typography color="textSecondary" variant="subtitle2">
                                                    Ganancia pago proveedor:
                                                </Typography>
                                                <Typography color="textPrimary">
                                                    {`${formatDinero((comprasDetalle.totalPagadoPrevisto - comprasDetalle.totalPagado))} ${comprasDetalle?.paquete?.MonedaProveedor?.Clave}`}
                                                </Typography>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Card className={classes.root}>
                    <CardContent>
                        <Grid container>
                            <Grid item xs={12}>
                                <div style={{ marginBottom: "1rem" }}>
                                    <Typography color="textSecondary" variant="h6" >
                                        Desglose de utilidad
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item xs={6}>
                                <div className={classes.pos}>
                                    <Typography color="textSecondary" variant="subtitle2">
                                        Utilidad por paquete y suplementos prevista:
                                    </Typography>
                                    <Typography color="textPrimary">
                                        {`${formatDinero(comprasDetalle.utilidadPaquetePrevista)} ${comprasDetalle?.paquete?.MonedaProveedor?.Clave}`}
                                    </Typography>
                                </div>
                                <div className={classes.pos}>
                                    <Typography color="textSecondary" variant="subtitle2">
                                        Utilidad corte de caja prevista:
                                    </Typography>
                                    <Typography color="textPrimary">
                                        {`${formatDinero(comprasDetalle.utilidadCorteCajaPrevista)} ${comprasDetalle?.paquete?.MonedaProveedor?.Clave}`}
                                    </Typography>
                                </div>

                                <div className={classes.pos}>
                                    <Typography color="textSecondary" variant="subtitle2">
                                        Monto faltante por liquidar prevista:
                                    </Typography>
                                    <Typography color="textPrimary">
                                        {`${formatDinero((comprasDetalle.sobranteComprasLiquidarPrevista > 0) ? -comprasDetalle.sobranteComprasLiquidarPrevista : comprasDetalle.sobranteComprasLiquidarPrevista)} ${comprasDetalle?.paquete?.MonedaProveedor?.Clave}`}
                                    </Typography>
                                </div>
                                <div className={classes.pos}>
                                    <Typography color="textSecondary" variant="subtitle2">
                                        Utilidad sobrante de compras prevista:
                                    </Typography>
                                    <Typography color="textPrimary">
                                        {`${formatDinero(comprasDetalle.utilidadSobranteComprasPrevista)} ${comprasDetalle?.paquete?.MonedaProveedor?.Clave}`}
                                    </Typography>
                                </div>
                                <div className={classes.pos}>
                                    <Typography color="textSecondary" variant="subtitle2">
                                        Utilidad total prevista:
                                    </Typography>
                                    <Typography color="textPrimary">
                                        {`${formatDinero(comprasDetalle.utilidadTotalPrevista)} ${comprasDetalle?.paquete?.MonedaProveedor?.Clave}`}
                                    </Typography>
                                </div>
                                <div className={classes.pos}>
                                    <Typography color="textSecondary" variant="subtitle2">
                                        Utilidad total prevista %:
                                    </Typography>
                                    <Typography color="textPrimary">
                                        {`${calcularProcentaje({ monto: comprasDetalle.utilidadTotalPrevista, total: totalPaqueteDolares })}%`}
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item xs={6}>
                                <div className={classes.pos}>
                                    <Typography color="textSecondary" variant="subtitle2">
                                        Utilidad por paquete y suplementos real:
                                    </Typography>
                                    <Typography color="textPrimary">
                                        {`${formatDinero(comprasDetalle.utilidadPaquete)} ${comprasDetalle?.paquete?.MonedaProveedor?.Clave}`}
                                    </Typography>
                                </div>
                                <div className={classes.pos}>
                                    <Typography color="textSecondary" variant="subtitle2">
                                        Utilidad corte de caja real:
                                    </Typography>
                                    <Typography color="textPrimary">
                                        {`${formatDinero(comprasDetalle.utilidadCorteCaja)} ${comprasDetalle?.paquete?.MonedaProveedor?.Clave}`}
                                    </Typography>
                                </div>

                                <div className={classes.pos}>
                                    <Typography color="textSecondary" variant="subtitle2">
                                        Monto faltante por liquidar real:
                                    </Typography>
                                    <Typography color="textPrimary">
                                        {`${formatDinero((comprasDetalle.sobranteComprasLiquidar > 0) ? - comprasDetalle.sobranteComprasLiquidar : comprasDetalle.sobranteComprasLiquidar)} ${comprasDetalle?.paquete?.MonedaProveedor?.Clave}`}
                                    </Typography>
                                </div>
                                <div className={classes.pos}>
                                    <Typography color="textSecondary" variant="subtitle2">
                                        Utilidad sobrante de compras real:
                                    </Typography>
                                    <Typography color="textPrimary">
                                        {`${formatDinero(comprasDetalle.utilidadSobranteCompras)} ${comprasDetalle?.paquete?.MonedaProveedor?.Clave}`}
                                    </Typography>
                                </div>
                                <div className={classes.pos}>
                                    <Typography color="textSecondary" variant="subtitle2">
                                        Utilidad total real:
                                    </Typography>
                                    <Typography color="textPrimary">
                                        {`${formatDinero(comprasDetalle.utilidadTotal)} ${comprasDetalle?.paquete?.MonedaProveedor?.Clave}`}
                                    </Typography>
                                </div>
                                <div className={classes.pos}>
                                    <Typography color="textSecondary" variant="subtitle2">
                                        Utilidad total real %:
                                    </Typography>
                                    <Typography color="textPrimary">
                                        {`${porcentajeUtlidadTotalReal}%`}
                                    </Typography>
                                </div>
                            </Grid>
                            {/* <Grid item xs={6}>
                                <Grafica
                                    labels={['% Utilidad', '% Proveedor']}
                                    valores={[
                                        calcularProcentaje({ monto: comprasDetalle.utilidadTotalPrevista, total: totalPaqueteDolares }),
                                        calcularProcentaje({ monto: comprasDetalle.montoNetoTotalPrevisto, total: totalPaqueteDolares }),
                                    ]}
                                />
                                <Grafica
                                    labels={['% Utilidad paquete', '% Corte de caja', '% Sobrante']}
                                    valores={[
                                        calcularProcentaje({ monto: comprasDetalle.utilidadPaquetePrevista, total: comprasDetalle.utilidadTotalPrevista }),
                                        calcularProcentaje({ monto: comprasDetalle.utilidadCorteCajaPrevista, total: comprasDetalle.utilidadTotalPrevista }),
                                        calcularProcentaje({ monto: comprasDetalle.utilidadSobranteComprasPrevista, total: comprasDetalle.utilidadTotalPrevista }),
                                    ]}
                                />
                            </Grid> */}
                        </Grid>
                    </CardContent>
                </Card>
                <Card className={classes.root}>
                    <CardContent>
                        <Grid container>
                            <Grid item xs={12}>
                                <div style={{ marginBottom: "1rem" }}>
                                    <Typography color="textSecondary" variant="h6" >
                                        Graficas
                                    </Typography>
                                </div>
                            </Grid>
                            <Grid item xs={12} >
                                <div style={{ marginBottom: "1rem" }}>
                                    <Grid container>
                                        <Grid item xs={6}>
                                            <div style={{ marginBottom: "1rem" }}>
                                                <Typography color="textSecondary" variant="h6" >
                                                    Monto paquete
                                                </Typography>
                                            </div>
                                            {/* <Grafica
                                                labels={['% Utilidad', '% Proveedor']}
                                                valores={[
                                                    calcularProcentaje({ monto: comprasDetalle.utilidadTotal, total: totalPaqueteDolares }),
                                                    calcularProcentaje({ monto: comprasDetalle.totalPagado, total: totalPaqueteDolares }),
                                                ]}
                                            /> */}
                                            <GraficaBarras
                                                label="%"
                                                labels={['% Utilidad', '% Proveedor']}
                                                valores={[
                                                    porcentajeUtlidadTotalReal,
                                                    porcentajeTotalPagadoProveedor,
                                                ]}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <div style={{ marginBottom: "1rem" }}>
                                                <Typography color="textSecondary" variant="h6" >
                                                    Desglose utilidad
                                                </Typography>
                                            </div>
                                            {/* <Grafica
                                                labels={['% Utilidad paquete', '% Corte de caja', '% Sobrante', '% Perdida']}
                                                valores={[
                                                    calcularProcentaje({ monto: comprasDetalle.utilidadPaquete, total: totalUtilidad }),
                                                    calcularProcentaje({ monto: comprasDetalle.utilidadCorteCaja, total: totalUtilidad }),
                                                    calcularProcentaje({ monto: comprasDetalle.utilidadSobranteCompras, total: totalUtilidad }),
                                                    calcularProcentaje({ monto: comprasDetalle.sobranteComprasLiquidar, total: totalUtilidad }),
                                                ]}
                                            /> */}
                                            <GraficaBarras
                                                label="%"
                                                labels={['% Utilidad paquete', '% Corte de caja', '% Sobrante']}
                                                valores={[
                                                    porcentajeUtlidadPaquete,
                                                    porcentajeUtidadCorteCaja,
                                                    porcentajeSobranteCompras
                                                ]}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <div style={{ marginBottom: "1rem" }}>
                                                <Typography color="textSecondary" variant="h6" >
                                                    Perdidas
                                                </Typography>
                                            </div>
                                            {/* <Grafica
                                                labels={['% Utilidad paquete', '% Corte de caja', '% Sobrante', '% Perdida']}
                                                valores={[
                                                    calcularProcentaje({ monto: comprasDetalle.utilidadPaquete, total: totalUtilidad }),
                                                    calcularProcentaje({ monto: comprasDetalle.utilidadCorteCaja, total: totalUtilidad }),
                                                    calcularProcentaje({ monto: comprasDetalle.utilidadSobranteCompras, total: totalUtilidad }),
                                                    calcularProcentaje({ monto: comprasDetalle.sobranteComprasLiquidar, total: totalUtilidad }),
                                                ]}
                                            /> */}
                                            <GraficaPerdidas
                                                label="%"
                                                labels={['% Perdida', '% Utilidad real']}
                                                valores={[
                                                    porcentajePerdida,
                                                    porcentajeUtlidadPaquete +
                                                    porcentajeUtidadCorteCaja +
                                                    porcentajeSobranteCompras
                                                ]}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </div>
        </div>
    )
}
export default Cabecera